function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("title", null, "Deposit");

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "Page-1",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "Deposit"
}, /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle",
  fill: "#FFFFFF",
  opacity: 0,
  x: 0,
  y: 0,
  width: 28,
  height: 28
}), /*#__PURE__*/React.createElement("path", {
  d: "M23.3194791,2.0744337 C23.3290964,2.16048743 23.3339163,2.24700979 23.3339163,2.33359926 L23.3339163,4.66444987 L3.50008744,4.66608371 C2.92733339,4.66608371 2.45097504,5.07880273 2.35218866,5.62306448 L2.33339163,5.83277952 C2.33339163,6.40553357 2.74611065,6.88189193 3.2903724,6.98067831 L3.50008744,6.99947534 L25.6673079,6.99947534 C26.9560045,6.99947534 28.0006995,8.04417035 28.0006995,9.33286697 L28.0006995,25.6666084 C28.0006995,26.955305 26.9560045,28 25.6673079,28 L2.33339163,28 C1.04469502,28 -5.96855898e-13,26.955305 -5.96855898e-13,25.6666084 L-5.96855898e-13,9.33286697 L0.00700017489,9.20756337 L0.00112514381,9.09587867 L-5.96855898e-13,4.41983172 C-5.96855898e-13,3.23142483 0.893172099,2.23287147 2.07422607,2.10087728 L20.7413591,0.014644822 C22.0220823,-0.128488366 23.1763459,0.793710528 23.3194791,2.0744337 Z M23.3339163,16.3330419 C22.0452197,16.3330419 21.0005247,17.3777369 21.0005247,18.6664335 C21.0005247,19.9551301 22.0452197,20.9998251 23.3339163,20.9998251 C24.6226129,20.9998251 25.6673079,19.9551301 25.6673079,18.6664335 C25.6673079,17.3777369 24.6226129,16.3330419 23.3339163,16.3330419 Z",
  id: "wallet",
  fill: "#3366CC"
})));

var SvgDeposit = function SvgDeposit(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "28px",
    height: "28px",
    viewBox: "0 0 28 28",
    ref: svgRef
  }, props), title === undefined ? _ref2 : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgDeposit, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/deposit.a618f249.svg";
export { ForwardRef as ReactComponent };